// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"607":"Root","836":"EmbeddedLoader"}[chunkId] || chunkId) + "." + {"607":"61e88532","836":"db3e0b1b","845":"8c58c53b"}[chunkId] + ".chunk.js";
};